/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_TitleInputs */

const en_cp_why_title = /** @type {(inputs: Cp_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not AI doing the students' homework`)
};

const id_cp_why_title = /** @type {(inputs: Cp_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukan AI yang mengerjakan tugas mahasiswa`)
};

/**
* | output |
* | --- |
* | "Not AI doing the students' homework" |
*
* @param {Cp_Why_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_title = /** @type {((inputs?: Cp_Why_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_title(inputs)
	return en_cp_why_title(inputs)
});